import { MapPin, Clock, Wine } from "lucide-react";

export default function Visit() {
  return (
    <section id="visit" data-testid="visit-section" className="py-24 md:py-32 bg-white border-b border-[#E7E5E4]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <p className="text-sm uppercase tracking-[0.25em] font-semibold text-[#4A5D23]">The Experience</p>
          <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-[#1C1917]">
            A cellar door made for slow afternoons
          </h2>
          <p className="mt-6 text-[#57534E] text-lg leading-relaxed">
            Gledswood Cellar Door welcomes you to taste boutique wines guided by
            our resident Sommelier. Pull up a stool, share a grazing board, and
            settle in.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { icon: Clock, title: "Opening Hours", body: "Thu–Sat 11am–2pm & the first Sunday of every month · Friday Night Wine Bar 6pm–11pm" },
              { icon: MapPin, title: "Location", body: "900 Camden Valley Way, Gledswood Hills NSW 2557" },
              { icon: Wine, title: "Tastings", body: "Hourly sittings from 11am to 2pm" },
            ].map((c) => (
              <div key={c.title} className="rounded-2xl bg-[#FDFBF7] border border-[#E7E5E4] p-5">
                <c.icon className="h-6 w-6 text-[#4A5D23]" />
                <h3 className="mt-3 font-semibold text-[#1C1917]">{c.title}</h3>
                <p className="mt-1 text-sm text-[#57534E]">{c.body}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-sm border border-[#E7E5E4]">
          <img
            src="https://customer-assets.emergentagent.com/job_wine-tasting-book/artifacts/wuysnna9_Gledswood%20Menu%20Shoot-8.png"
            alt="Gledswood Homestead Winery Shiraz on a candlelit table"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
